"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BaseTheme = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSvg = require("react-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseTheme = /*#__PURE__*/_createClass(function BaseTheme() {
  var _this = this;

  _classCallCheck(this, BaseTheme);

  this.name = 'BaseTheme';
  this.baseAssetLocation = "assets/".concat(this.name.toLowerCase(), "/");
  this.localThemes = {};

  this.localThemer = function (componentName, defaultTheme) {
    if (_this.localThemes && _this.localThemes[componentName]) return _this.localThemes[componentName];
    return defaultTheme;
  };

  this.setLocalTheme = function (componentName, localTheme) {
    _this.localThemes[componentName] = localTheme;
  };

  this.setBaseAssetLocation = function (path) {
    _this.baseAssetLocation = path;
  };

  this.getAssetLocation = function (assetType) {
    return "".concat(_this.baseAssetLocation).concat(_this.assetLocations[assetType]);
  };

  this.setAssetLocations = function (assetType, path) {
    _this.assetLocations[assetType] = path.endsWith('/') ? path : "".concat(path, "/");
  };

  this.assetLocations = {
    fonts: 'fonts/',
    icons: 'icons/',
    logos: 'logos/'
  };
  this.customRouter = undefined;

  this.setCustomRouter = function (router) {
    _this.customRouter = router;
  };

  this.iconRules = {
    system: {
      assetLocation: '',
      properties: function properties() {}
    },
    state: {
      assetLocation: '',
      properties: function properties() {}
    }
  };

  this.setIconGroup = function (groupName, assetLocation, ruleSet) {
    var iconSet = _this.iconRules[groupName];

    if (iconSet) {
      iconSet.assetLocation = assetLocation;
      iconSet.properties = ruleSet || iconSet.properties;
      return;
    }

    for (var group in _this.iconRules) {
      if (_this.iconRules[group].assetLocation === assetLocation) console.warn('The asset location you are trying to use already exists');
    }

    _this.iconRules[groupName] = {
      assetLocation: assetLocation,
      properties: ruleSet || _this.iconRules["default"].properties
    };
  };

  this.getIcon = function (iconName, groupName, ErrorComponent) {
    var _this$iconRules$group;

    return /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
      fallback: function fallback() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ErrorComponent || null);
      },
      src: "".concat(_this.baseAssetLocation).concat(_this.assetLocations.icons).concat((_this$iconRules$group = _this.iconRules[groupName]) === null || _this$iconRules$group === void 0 ? void 0 : _this$iconRules$group.assetLocation, "/").concat(iconName, ".svg"),
      wrapper: "span"
    });
  };

  this.doesIconGroupExist = function (groupName) {
    return !!_this.iconRules[groupName];
  };

  this.getIconProperties = function (groupName) {
    return _this.iconRules[groupName].properties(_this);
  };

  this.getLogo = function (logoName) {
    return /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
      src: "".concat(_this.getAssetLocation('logos')).concat(logoName, ".svg"),
      wrapper: "span"
    });
  };
});

exports.BaseTheme = BaseTheme;
var _default = BaseTheme;
exports["default"] = _default;
//# sourceMappingURL=BaseTheme.js.map